import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AgendaSigningApiService } from 'src/app/core/service/apis/sprintful/agenda-signing-api.service';
import { SprintfulRecordResponse } from 'src/app/shared/models/sprintful/sprintful.model';

/**
 * Trae registros Sprintful por recordId (`POST {api}/sprintful/detail`). Compartido por
 * `capabilities/agenda-signing` y `profiles/laser/agenda-signing`.
 */
@Injectable({
  providedIn: 'root',
})
export class SprintfulRecordsService {
  private readonly api = inject(AgendaSigningApiService);

  /** Ids vacíos/falsy se descartan; sin ids reales, corta antes de pegarle al back. */
  fetchByRecordIds(recordIds: string[]): Observable<SprintfulRecordResponse[]> {
    const ids = (recordIds ?? []).filter(Boolean);
    if (!ids.length) return of([]);

    return this.api.getSprintfulDetail(ids).pipe(
      map(records => records ?? []),
    );
  }
}
